import { client } from "../../../../actions";
import { authHeader } from "../../../../helpers/auth-header";
import parseBackendFileErrorResponse from "../../../../helpers/parseBackendFileErrorResponse";

const saveReport = async (file) => {
	const formData = new FormData();
	formData.append("excelFile", file);
	const contentType = {};
	if (file.type === "text/csv" || file.name.split(".").pop() === "csv") {
		contentType["Content-Type"] = "text/csv";
	}
	try {
		const response = await client.post("/Meter/upload_report_meter", formData, {
			headers: { ...authHeader(), ...contentType },
		});
		if (response.data.result === "Error") {
			const message = parseBackendFileErrorResponse(response.data.message);
			return {
				type: "warning",
				text: message.parsed
					? `Внимание! Данные не загружены. Ошибка в строке №${message.value}. 
					Проверьте адрес, номер дома, корпус или тип счетчика`
					: message.value,
			};
		} else {
			return { type: "success", text: "Файл успешно загружен" };
		}
	} catch (error) {
		console.log(error);
		return {
			type: "error",
			text: "Произошла ошибка, проверьте, пожалуйста, соответствует ли файл шаблону.",
		};
	}
};

export default saveReport;
